module.exports = __webpack_public_path__ + "static/media/backWhite.fb78eb00.svg";